import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgProtectionDamageFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#protection-damage-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E8E8E8",
        d: "m34.973 27.23 3.724 2.758-5.72 3.888-.071 3.926-.235.032c-.059.007-4.82.522-7.35 7.938.006.072.006.13.012.202.118.176.235.359.359.535.952 1.056 1.944 2.178 2.694 3.378q.236.306.463.62c.398.078.789.13 1.141.124 1.129-.111 2.994-1.422 4.116-1.428 2.171-1.716 5.152-4.286 8.635-7.86 3.359-3.443 4.963-6.241 5.713-8.263.02-.04.04-.078.059-.124 1.565-3.705.567-7.846-2.185-10.468.522-.659 2.028-2.485 3.444-3.47l-7.253-3.065-.11-.046-4.905-2.074c-.666-.509-1.65-1.265-1.65-1.265l-.679.28h-.02c.281 1.69.027 4.064-.084 4.898a9.45 9.45 0 0 0-3.529.522c1.213.88 3.47 3 4.37 7.031"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8FA7A0",
        d: "M28.594 38.285c1.461-1.278 2.805-1.787 3.333-1.957l-.267-3.737 4.956-4.063-3.698-2.25.907-2.146c-1.318-4.018-3.979-5.811-5.022-6.379a9.34 9.34 0 0 0-4.41 5.355c-.012.046-.019.091-.032.13-.743 2.023-1.356 5.192-1.05 9.992.307 4.833.874 8.649 1.39 11.355.984-3.189 2.582-5.152 3.893-6.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8FA7A0",
        d: "M47.032 22.22c.522-.658 2.029-2.484 3.444-3.469l-7.253-3.065-.11-.046-7.253-3.065c.28 1.695.026 4.05-.085 4.885a9.5 9.5 0 0 0-3.528.541c1.213.88 3.47 3 4.37 7.03l.019.099-.965 1.813 3.724 2.759-5.72 3.887-.072 3.926-.235.033c-.058.006-5.59.88-8.113 8.296.28 2.36.56 3.607.56 3.607l2.557 1.082.111.046 2.557 1.083s5.12-3.124 12.405-10.586c3.359-3.443 4.963-6.241 5.713-8.263q.03-.058.06-.124c1.564-3.705.566-7.846-2.186-10.468"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M28.608 10.272s1.043.633 2.008 2.068l2.381-1.63s-.157-1.364-.241-2.16l-2.12-.822L28.27 8.89s.32.94.345 1.383z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M29.182 9.88s1.043.633 2.009 2.068l2.38-1.63s-.156-1.364-.241-2.16l-2.12-.821-2.367 1.16s.32.94.346 1.383z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m25.02 6.998.92 1.859s.567 0 .593-.079c.033-.071.568-1.924.568-1.924l-2.087.144z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "m25.366 6.991.92 1.859s.567 0 .6-.078c.032-.072.567-1.924.567-1.924z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M35.455 24.621s1.657.235 3.855 1.305l1.415-2.531-1.937-2.061-3.02-.02-1.767 2.055s1.09.815 1.454 1.246z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E42612",
        d: "M35.795 24.014s1.657.235 3.848 1.304l1.415-2.53-1.937-2.061-3.02-.02-1.767 2.055s1.09.815 1.454 1.245z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m25.366 37.873.842 4.657 2.889 1.213 1.676-.841s-1.115-1.396-1.383-4.298l-3.195-1.09z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E42612",
        d: "m26.161 37.502.841 4.656 2.89 1.214 1.676-.842s-1.115-1.395-1.585-3.73l-3.822-1.305z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m52.843 32.78-1.8-1.742s.313-.495.417-.489c.111.006 2.694.463 2.694.463l-1.318 1.761z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "m53.046 32.48-1.794-1.742s.313-.495.417-.489c.111.007 2.694.463 2.694.463l-1.318 1.761z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#385B66",
        d: "m50.522 18.777-2.864-1.207s.959.757-1.532 3.105c-1.337 1.258-2.061 2.746.358 6.313 2.42 3.574.346 9.568-1.878 12.268a365 365 0 0 1-3.541 4.246s3.398-3.033 5.96-6.633c1.181-1.657 2.107-3.502 2.577-5.1.763-2.616.333-4.71-.359-6.405-.796-1.963-2.165-3.124-2.165-3.124s1.193-1.409 1.617-1.865c.685-.744 1.827-1.605 1.827-1.605z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M25.738 16.85c-6.06.044-9.178-2.05-10.194-2.956-1.016.906-4.253 2.998-10.312 2.957 0 0-.798 9.68.782 14.47 1.158 3.507 5.487 5.797 9.203 7.36l.271.124.7-.307c3.615-1.557 7.659-3.804 8.771-7.177 1.58-4.79.779-14.47.779-14.47"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "m25.747 16.992-.023-.036c-1.497 7.842-5.256 13.572-10.194 6.432v15.4c.098-.043.345-.15.655-.287 3.614-1.557 7.658-3.804 8.771-7.177 1.469-4.454.881-13.135.791-14.332",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "m17.093 38.095-.82-5.937c-5.693 1.44-8.577-.148-10.83-4.466a3 3 0 0 0-.184-.314c.15 1.456.388 2.83.755 3.941 1.157 3.507 5.487 5.798 9.203 7.36l.27.124s.298-.129.7-.306q.45-.194.906-.402",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m15.48 18.627 1.356 5.34 5.498-.36-4.66 2.939 2.042 5.118-4.236-3.525-4.236 3.525 2.043-5.118-4.66-2.94 5.498.362z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `protection-damage-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgProtectionDamageFidelityLow;
